<template>
    <div>
        <canvas :id="identifier" class="custom-chart"></canvas>
    </div>
</template>

<script>

import { Chart } from 'chart.js';

export default {
    name: "CustomChart",
    props: ['type', 'datasets', 'labels', 'options'],
    data() {
        return {
            identifier: Math.random().toString(36).substr(2, 9),
            chartJsInstance: null,
            isRendering: false,
            lastDataHash: null
        };
    },
    watch: {
        // Watchers avec immediate: false pour éviter la récursion au montage
        datasets: {
            handler() {
                if (!this.isRendering) {
                    this.$nextTick(() => this.renderChart());
                }
            },
            immediate: false,
            deep: false
        },
        labels: {
            handler() {
                if (!this.isRendering) {
                    this.$nextTick(() => this.renderChart());
                }
            },
            immediate: false,
            deep: false
        },
        type: {
            handler() {
                if (!this.isRendering) {
                    this.$nextTick(() => this.renderChart());
                }
            },
            immediate: false,
            deep: false
        }
    },
    methods: {
        renderChart() {
            // Protection contre les appels multiples
            if (this.isRendering) {
                console.log('Déjà en cours de rendu, abandon');
                return;
            }
            
            // Vérifier que les données existent
            if (!this.datasets || !this.labels || !this.type) {
                console.log('Données manquantes:', { datasets: !!this.datasets, labels: !!this.labels, type: !!this.type });
                return;
            }
            
            console.log('Début du rendu du graphique');
            this.isRendering = true;
            
            if (this.chartJsInstance != null) {
                this.chartJsInstance.destroy();
            }
            
            // Clone simple pour éviter les références circulaires
            let safeDatasets, safeLabels, safeOptions;
            
            try {
                safeDatasets = JSON.parse(JSON.stringify(this.datasets || []));
            } catch (e) {
                console.log('Erreur de clonage datasets:', e);
                safeDatasets = this.datasets || [];
            }
            
            try {
                safeLabels = JSON.parse(JSON.stringify(this.labels || []));
            } catch (e) {
                console.log('Erreur de clonage labels:', e);
                safeLabels = this.labels || [];
            }
            
            try {
                safeOptions = this.options ? JSON.parse(JSON.stringify(this.options)) : {};
            } catch (e) {
                console.log('Erreur de clonage options:', e);
                safeOptions = this.options || {};
            }

            this.chartJsInstance = new Chart(this.identifier, {
                type: this.type,
                data: {
                    labels: safeLabels,
                    datasets: safeDatasets
                },
                options: {
                    responsive: false,
                    maintainAspectRatio: false,
                    plugins: {
                        annotation: {
                            annotations: {}
                        },
                    },
                    ...safeOptions
                }
            });
            
            console.log('Init custom chart ' , Chart.version);
            this.isRendering = false;
        },
        updateChart() {
            if (this.chartJsInstance) {
                this.chartJsInstance.update();
            }
        },
    
    },
    mounted() {
        // Attendre que le DOM soit prêt
        setTimeout(() => {
            this.renderChart();
        }, 100);
    },
    // Désactivé temporairement pour éviter la récursion
    // updated() {
    //     this.$nextTick(() => {
    //         this.renderChart();
    //     });
    // },
    beforeDestroy() {
        if (this.chartJsInstance != null) {
            this.chartJsInstance.destroy();
        }
    }
}
</script>


